import React, { useState, useEffect, useContext } from "react"
import { useParams, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Table,
} from "reactstrap"
import { Tooltip } from "react-tooltip"
import { formatDateTime, uId } from "common/utility"
import {
  getOneConfirmOrder,
  getShipmentDetails,
  getTrackingDetails,
} from "http/order/order"
import TrackOrder from "pages/Dealer-order2/trackOrderModal"
import { formatNumberWithCommas } from "../../common/utility"
import { startCase } from "lodash"
import ShipmentDetails from "components/ShipmentDetails"
import ToastDialog from "common/ToastDialog"
import { SystemConfigurationContext } from "context/systemConfigContext"
import { getAllRegions } from "helpers/UAM/region.helper"

const ViewSubOrder = () => {
  const [confirmOrders, setConfirmOrders] = useState({})
  const [modal1, setModal1] = useState(false)
  const { id } = useParams()
  const navigate = useNavigate()
  const [orderId, setOrderId] = useState(null)
  const [open, setOpen] = useState("1")
  const [history, setHistory] = useState(null)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [trackingDetails, setTrackingDetails] = useState("")
  const { sapTrigger } = useContext(SystemConfigurationContext)
  const [hasError, setHasError] = useState([]);
  const [orderReasonOptions, setOrderReasonOptions] = useState([])

  const toggle = id => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  useEffect(() => {
    if (id) {
      fetchConfirmOrder()
    }
    fetchOrderReason()
  }, [id])

  const fetchShipmentDetails = async () => {
    try {
      const response = await getShipmentDetails({
        orderCode: confirmOrders?.orderCode,
      })
      if (response.status) {
        setHistory(response?.data)
      } else {
        setHistory([])
      }
    } catch (e) {
      console.error(e)
    }
  }

  const fetchConfirmOrder = () => {
    getOneConfirmOrder({ id })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          const orderData = responseFromAPI.data
          setConfirmOrders(orderData)
        }
      })
      .catch(error => { })
  }

  const fetchTrackingDetails = async () => {
    try {
      const response = await getTrackingDetails({
        orderId: confirmOrders?.id,
      })
      if (response.status) {
        setTrackingDetails(response?.data?.trackingDetails)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    navigate(-1)
  }

  const toggleViewModal = id => {
    if (!modal1) {
      setOrderId(id)
      setModal1(true)
    } else {
      setOrderId(null)
      setModal1(false)
    }
  }

  useEffect(() => {
    if (confirmOrders?.orderCode) {
      fetchShipmentDetails()
      fetchTrackingDetails()
    }
  }, [confirmOrders])

  const fetchOrderReason = async () => {
    try {
      let res = await getAllRegions({ dropdownName: 'order_reasons' })
      if (res.status) {
        setOrderReasonOptions(
          res?.data?.regions[0]?.dropdownValues?.map(i => ({
            label: `${i.displayName} (${i.dropdownValue})`,
            value: i.dropdownValue,
          }))
        )
      } else {
        setOrderReasonOptions([])
      }
    } catch (error) {
      setOrderReasonOptions([])
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumbs title="Order" breadcrumbItem="Order Details" />
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleCancel}
            >
              Back
            </button>
          </div>
        </div>
        <Card key={confirmOrders?.id} className="mb-3">
          <CardBody>
            <Row>
              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Order Request ID
                  </Label>
                  <p>{confirmOrders?.requestOrder?.orderCode}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Order ID
                  </Label>
                  <p>{confirmOrders?.orderCode}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    SAP Order ID
                  </Label>
                  <p>{confirmOrders?.sapOrderId || '-'}</p>
                </div>
              </Col>

              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Date
                  </Label>
                  <p>{formatDateTime(confirmOrders?.orderDate)}</p>
                </div>
              </Col>

              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Total Amount
                  </Label>
                  <p>{formatNumberWithCommas(confirmOrders?.totalAmount)}</p>
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="mb-0 color-label fw-bold text-secondary">
                    Plant
                  </Label>
                  <p data-tooltip-id={`plant-tooltip${confirmOrders.id}`}>
                    {confirmOrders?.plantDescription?.length > 20
                      ? `${confirmOrders.plantDescription?.substring(0, 20)}...`
                      : confirmOrders.plantDescription || "NA"}
                  </p>
                  <Tooltip
                    style={{ maxWidth: "200px", marginLeft: "1rem" }}
                    id={`plant-tooltip${confirmOrders.id}`}
                    place="top"
                    content={confirmOrders?.plantDescription}
                  />
                </div>
              </Col>
              <Col xs="6" md="2">
                <div>
                  <Label htmlFor="dealerType" className="mb-0 color-label fw-bold text-secondary">
                    Payment Terms
                  </Label>
                  <p data-tooltip-id={`payment-tooltip${confirmOrders.id}`}>
                    {confirmOrders?.paymentTermsDescription?.length > 20
                      ? `${confirmOrders.paymentTermsDescription?.substring(0, 20)}...`
                      : confirmOrders.paymentTermsDescription || "NA"}
                  </p>
                  <Tooltip
                    style={{ maxWidth: "200px", marginLeft: "1rem" }}
                    id={`payment-tooltip${confirmOrders.id}`}
                    place="top"
                    content={confirmOrders?.paymentTermsDescription}
                  />
                </div>
              </Col>

              <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                <div className="mb-3">
                  <Label htmlFor="dealerType" className="label-styling">
                    Order Reason
                  </Label>
                  <p>
                    {(() => {
                      const found = orderReasonOptions?.find(opt => opt.value === confirmOrders?.orderReason);
                      return found ? `${found.label}` : '-';
                    })()}
                  </p>
                </div>
              </Col>

              <Col xs="12" md="2" style={{ marginRight: "30px" }}>
                <div className="mb-3">
                  <Label htmlFor="shipToParty" className="label-styling">
                    Ship to Party
                  </Label>
                  <p>{confirmOrders?.shipToParty || '-'}</p>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Tracking Details
                  </Label>
                  {trackingDetails ? (
                    <p data-tooltip-id="tracking-tooltip">
                      {trackingDetails?.length > 20
                        ? trackingDetails?.substring(0, 20) + "..."
                        : trackingDetails}
                    </p>
                  ) : (
                    <p

                    >
                      NA
                    </p>
                  )}

                  <Tooltip
                    style={{ maxWidth: "500px", marginLeft: "1rem" }}
                    id={`tracking-tooltip`}
                    place="top"
                    content={trackingDetails}
                  />
                </div>
              </Col>
              <Col xs="6" md="2">
                <div className="mb-3">
                  <Label
                    htmlFor="dealerType"
                    className="mb-0 color-label fw-bold text-secondary"
                  >
                    Orders Status
                  </Label>

                  <p
                    className="py-1 status-pill bg-green rounded-pill text-white"
                  >
                    {startCase(confirmOrders?.orderStatus)}
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="">
                  <Accordion flush open={open} toggle={toggle}>
                    <AccordionItem className="">
                      <AccordionHeader
                        targetId="1"
                        style={{
                          borderBottom: "1px solid #adb5bd",
                          backgroundColor: "white",
                        }}
                      >
                        <h5 style={{ fontSize: "1rem", color: "#73778c" }}>
                          Product Details
                        </h5>
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        {sapTrigger ? (
                          <>
                            {history?.productDetails?.length > 0 && (
                              <div
                                style={{ display: "flex", flexDirection: "column" }}
                              >
                                <table
                                  className="table-responsive"
                                  style={{
                                    backgroundColor: "white",
                                    width: "100%",
                                  }}
                                >
                                  <thead
                                    style={{
                                      backgroundColor: "#f8f8fb",
                                      color: "#495057",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Image
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>
                                        Product Name
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>
                                        Product Code
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>Qty</th>
                                      <th style={{ padding: "1rem 0px" }}>Total Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {history?.productDetails?.map(
                                      (productItem, index) => {
                                        let imgUrl =
                                          productItem?.productImages?.find(
                                            imgItem => imgItem?.image?.primary
                                          )?.image?.paths?.original
                                        return (
                                          <tr
                                            key={uId()}
                                            style={{
                                              backgroundColor: "white",
                                              borderBottom: "1px solid #ddd",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                                paddingLeft: '0.6rem'
                                              }}
                                            >
                                              <div className={(imgUrl && !hasError[index]) ? "td-product-img" : "td-no-product-img"}>
                                                {
                                                  (imgUrl && !hasError[index]) ? (
                                                    <img
                                                      src={
                                                        process.env.REACT_APP_IMAGE_URL +
                                                        imgUrl
                                                      }
                                                      alt=""
                                                      style={{
                                                        cursor: "pointer",
                                                        width: '100%',
                                                        height: '4.5rem'

                                                      }}
                                                      onError={(e) => {
                                                        e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                                        e.target.src='/no-image.png';
                                                        e.target.style.width = '2.5rem'; 
                                                        e.target.style.height = '2.5rem'; 
                                                        setHasError(prevState => {
                                                          const newState = [...prevState];
                                                          newState[index] = true;
                                                          return newState;
                                                        });
                                                      }}
                                                      className="img-fluid d-block"
                                                    />
                                                  ) : (
                                                    <img
                                                      src={
                                                        "/no-image.png"
                                                      }
                                                      alt=""
                                                      className="img-fluid mx-auto d-block"
                                                      style={{
                                                        
                                                        cursor: "pointer",
                                                        width: '2rem'
                                                      }}
                                                    />
                                                  )
                                                }
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div>
                                                <p className="font-size-14">
                                                  {productItem?.productName}
                                                </p>
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {productItem.productId}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {productItem.quantity}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {formatNumberWithCommas(
                                                productItem.price * productItem.quantity
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                            {history?.length === 0 && (
                              <p className="text-center">No product details available at the moment.</p>
                            )}
                          </>
                        ) : (
                          <>
                            {confirmOrders?.orderedProducts?.length > 0 && (
                              <div
                                style={{ display: "flex", flexDirection: "column" }}
                              >
                                <table
                                  className="table-responsive"
                                  style={{
                                    backgroundColor: "white",
                                    width: "100%",
                                  }}
                                >
                                  <thead
                                    style={{
                                      backgroundColor: "#f8f8fb",
                                      color: "#495057",
                                    }}
                                  >
                                    <tr>
                                      <th style={{ padding: "1rem 10px" }}>
                                        Product Image
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>
                                        Product Name
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>
                                        Product Code
                                      </th>
                                      <th style={{ padding: "1rem 0px" }}>Qty</th>
                                      <th style={{ padding: "1rem 0px" }}>Total Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {confirmOrders?.orderedProducts?.map(
                                      (product, index) => {
                                        return (
                                          <tr
                                            key={uId()}
                                            style={{
                                              backgroundColor: "white",
                                              borderBottom: "1px solid #ddd",
                                            }}
                                          >
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                                paddingLeft: '0.6rem'
                                              }}
                                            >
                                              <div style={{border: 'none'}} className={(product?.product?.productImages[0]?.image
                                                  ?.paths?.original && !hasError[index]) ? "td-product-img" : "td-no-product-img"}>
                                                {(product?.product?.productImages[0]?.image
                                                  ?.paths?.original && !hasError[index]) ? (
                                                  <img
                                                    src={
                                                      process.env.REACT_APP_IMAGE_URL +
                                                      product?.product?.productImages[0]?.image
                                                        ?.paths?.original

                                                    }
                                                    alt=""
                                                    className="img-fluid d-block"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: '100%',
                                                      height: '4.5rem',
                                                 
                                                    }}
                                                    onError={(e) => {
                                                      e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                                      e.target.src='/no-image.png';
                                                      e.target.style.width = '2.5rem'; 
                                                      e.target.style.height = '2.5rem'; 
                                                      setHasError(prevState => {
                                                        const newState = [...prevState];
                                                        newState[index] = true;
                                                        return newState;
                                                      });
                                                    }}
                                                  />
                                                ) : (
                                                  <img
                                                    src={
                                                      "/no-image.png"
                                                    }

                                                    alt=""
                                                    className="img-fluid mx-auto d-block"
                                                    style={{
                                                      cursor: "pointer",
                                                      width: '2rem'
                                                    }}
                                                  />
                                                )}

                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <div>
                                                <p className="font-size-14">
                                                  {product?.product?.productName}
                                                </p>
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {product.product.sku}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {product.quantity}
                                            </td>
                                            <td
                                              style={{
                                                padding: "0.5rem 0",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              {formatNumberWithCommas(
                                                product.price * product.quantity
                                              )}

                                            </td>
                                          </tr>
                                        )
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </div>
              </Col>
            </Row>
            <Row className="">
              <ShipmentDetails
                deliveryDetails={history?.deliveryDetails || []}
                setToastInfo={setToastInfo}
              />
            </Row>
          </CardBody>
        </Card>
        {orderId && (
          <TrackOrder
            isOpen={modal1}
            toggle={toggleViewModal}
            orderId={orderId}
          />
        )}
      </Container>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </div>
  )
}

export default ViewSubOrder
